import { render, staticRenderFns } from "./elePageData.vue?vue&type=template&id=5b803dad&scoped=true&"
import script from "./elePageData.vue?vue&type=script&lang=js&"
export * from "./elePageData.vue?vue&type=script&lang=js&"
import style0 from "./elePageData.vue?vue&type=style&index=0&id=5b803dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b803dad",
  null
  
)

export default component.exports